import List from "@/components/list";
import Bus from "./Bus.js";
import router from "@/router";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function handleView({ row }) {
    Bus.$emit("video_audit_details", row);
  }

  const Deal = ({ props: { vo } }) => {
    let icon = "icon-steps";
    let explain = "查看审核进度";
    if (vo.row.auditStatus == 0 && vo.row.isAudit == true) {
      icon = "icon-audit";
      explain = "审核";
    }
    const dealConf = [
      [icon, explain, () => handleView(vo), "resource:audit:list"]
    ];

    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const ReportName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goClassReportDetail(item)}>
        {item.videoName}
      </div>
    );
  };
   // 点击跳转视频详情
   function goClassReportDetail(row) {
    router.push({
      path: "video/detail",
      query: { id: row.bizId },
    });
  }
  const AccountTableConfig = [
    {
      label: "视频名称",
      prop: "videoName",
      minWidth: "180",
      render: (vo) => <ReportName vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "审核单号",
      prop: "auditOrderNo",
      minWidth: "100"
    },
    {
      label: "审核类型",
      prop: "auditBizTypeName",
      width: "100"
    },
    {
      label: "审核状态",
      prop: "auditStatusName",
      width: "90"
    },
    {
      label: "审核发起者",
      prop: "createUserName",
      width: "100"
    },
    {
      label: "发起时间",
      prop: "createDate",
      width: "150"
    },
    {
      label: "操作",
      width: "80",
      fixed: "right",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
